(function(){
    'use strict';
    angular.module('app')
        .controller('AdministrationTeamActionsController', function(
            $scope,
            $location,
            AdminTeamActionTableService
        ){

            init();

            $scope.goBack = function(){
                $location.path('/administration');
            }

            function init() {
                $scope.tableData = new AdminTeamActionTableService().tableData;
            }
        })

})();


// WEBPACK FOOTER //
// ./js/controllers/administration/AdministrationTeamActionsController.js